/**
 * Step 4: Preview
 * Review composition before creating the composite Smart Asset.
 */
import type React from "react";
import type { SmartAssetData } from "../types";

export interface PreviewStepProps {
  availableAssets: SmartAssetData[];
  selectedAssetIds: string[];
  links: Array<{ id: string; source_id: string; target_id: string; link_type: string }>;
}

export const PreviewStep: React.FC<PreviewStepProps> = ({
  availableAssets,
  selectedAssetIds,
  links,
}) => {
  const selectedAssets = availableAssets.filter((a) => selectedAssetIds.includes(a.id));

  return (
    <div>
      <div className="mb-4">
        <p className="text-sm text-sa-text-muted">
          Review your composition before creating the new composite Smart Asset.
        </p>
      </div>

      <div className="bg-sa-surface-hover rounded-lg p-6 border border-sa-border">
        <h3 className="font-medium text-sa-text mb-4">Composition Summary</h3>

        <div className="mb-4">
          <p className="text-xs text-sa-text-muted mb-2">Components:</p>
          <div className="flex flex-wrap gap-2">
            {selectedAssets.map((asset) => (
              <div
                key={asset.id}
                className="flex items-center gap-2 px-3 py-1.5 bg-sa-surface rounded-lg border border-sa-border"
              >
                {asset.iconPath && (
                  <img src={asset.iconPath} alt={asset.name} className="w-5 h-5 rounded" />
                )}
                <span className="text-sm text-sa-text">{asset.name}</span>
              </div>
            ))}
          </div>
        </div>

        <div>
          <p className="text-xs text-sa-text-muted mb-2">Connections ({links.length}):</p>
          <div className="space-y-1">
            {links.map((link) => (
              <div key={link.id} className="text-sm text-sa-text flex items-center gap-2">
                <span
                  className={`w-2 h-2 rounded-full ${
                    link.link_type === "signal" ? "bg-primary" : "bg-amber-500"
                  }`}
                />
                {link.source_id} → {link.target_id}
              </div>
            ))}
          </div>
        </div>
      </div>

      <p className="mt-4 text-xs text-sa-text-muted italic">
        Full composition visualization coming soon. Proceed to create your composite.
      </p>
    </div>
  );
};
